import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme";
import { Box, Button as MuiButton } from "@mui/material";

const Cancellation = ({
  setOpen,
  title,
  warningMessage,
  actionText,
  actionButtonColor,
  cancelText,
  actionHandler,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog.Panel
      className="relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:w-full sm:max-w-lg"
      style={{ backgroundColor: colors.primary[500], border: `1px solid ${colors.primary[400]}` }}
    >
      <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div className="sm:flex sm:items-start">
          <div
            className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
            style={{ backgroundColor: "rgba(235, 87, 87, 0.1)" }}
          >
            <ExclamationTriangleIcon
              className="h-6 w-6"
              style={{ color: colors.off_red || "#EB5757" }}
              aria-hidden="true"
            />
          </div>
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <Dialog.Title
              as="h3"
              className="text-base font-semibold leading-6"
              style={{ color: colors.grey[100] }}
            >
              {title}
            </Dialog.Title>
            <div className="mt-2">
              <p className="text-sm" style={{ color: colors.grey[200] }}>{warningMessage}</p>
            </div>
          </div>
        </div>
      </div>
      <Box
        sx={{
          backgroundColor: colors.primary[400],
          px: 3,
          py: 2,
          display: "flex",
          flexDirection: { xs: "column", sm: "row-reverse" },
          gap: 1
        }}
      >
        <MuiButton
          onClick={actionHandler}
          variant="contained"
          sx={{
            backgroundColor: actionButtonColor?.includes('red') ? colors.redAccent[500] : colors.greenAccent[500],
            color: theme.palette.mode === "dark" ? colors.primary[500] : colors.primary[100],
            fontWeight: "bold",
            textTransform: "none",
            "&:hover": {
              backgroundColor: actionButtonColor?.includes('red') ? colors.redAccent[600] : colors.greenAccent[400],
            }
          }}
        >
          {actionText}
        </MuiButton>
        <MuiButton
          onClick={() => setOpen(false)}
          variant="outlined"
          sx={{
            borderColor: colors.grey[400],
            color: colors.grey[200],
            fontWeight: "bold",
            textTransform: "none",
            "&:hover": {
              borderColor: colors.grey[300],
              backgroundColor: "rgba(255, 255, 255, 0.05)",
            }
          }}
        >
          {cancelText}
        </MuiButton>
      </Box>
    </Dialog.Panel>
  );
};

Cancellation.propTypes = {
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  warningMessage: PropTypes.string.isRequired,
  actionText: PropTypes.string.isRequired,
  actionButtonColor: PropTypes.string,
  cancelText: PropTypes.string.isRequired,
  actionHandler: PropTypes.func.isRequired,
};

export default Cancellation;
